<template>
  <div class="on-print">
    <v-dialog v-model="loginDialog" width="400">
      <LoginDialog />
    </v-dialog>

    <div v-if="!globalStatus" class="on-print">
     
      <v-main>
        <router-view></router-view>
      </v-main>
      <!-- <v-footer app v-if="!$vuetify.breakpoint.xsOnly">
        <span>Need Help Call: (917) 529-7186</span>
        <v-spacer></v-spacer>
        <div>
          Power by: <span>taleem.app</span> &copy; {{ new Date().getFullYear() }} | V-{{ version }}
        </div>
      </v-footer> -->
    </div>
    <div v-else>
      <v-dialog v-model="globalStatus" hide-overlay persistent width="300">
        <v-card color="primary" class="pa-3" dark>
          <v-card-text>
            {{ $t("labels.pleaseStandBy") }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="loadingStatus.status" persistent width="300">
      <v-card color="purple darken-3" dark>
        <v-card-text>
          {{ loadingStatus.title }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import layoutStore from "./store";
// import Navbar from "@/modules/Layout/components/NavigationPanel.vue";
import LoginDialog from "@/modules/Authentication/components/LoginDialog.vue";
// import Toolbar from "@/modules/Layout/components/Toolbar.vue";
// import accountService from "@/modules/Account/service.js";
import backofficeService from "../../api/backoffice.js";
// import CancelDialog from "@/modules/Layout/components/cancelDialog.vue";
import { mapGetters, mapActions } from "vuex";
// const pjson = require("../../../../../package.json");

export default {
  name: "teacher-layout",
  async created() {
    try {
      await this.registerStoreModule("teacherLayout", layoutStore);
      await this.initUser();
      await this.initType();
      this.setGlobalStatus(false);
      this.pollData();
      // if (this.currentBusiness.subscribable) this.checkSubcription();
      // console.log('currentBusiness', this.currentBusiness)
    } catch (error) {
      this.$router.push("/logout");
    }
  },
  mixins: [RegisterStoreModule],
  components: {
    // CancelDialog,
    LoginDialog,
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "currentBusiness",
      "globalStatus",
      "loadingStatus",
      "loginDialog",
    ]),
  },
  props: {
    source: String,
  },
  data() {
    return {
      subscriptionStatus: "active",
      showCancel: false,
      include: ["home", "customer-home"],
      authenticated: true,
      polling: null,
      Subscription: null,
    };
  },
  watch: {
    subscriptionStatus(val) {
      if (val === "canceled") {
        this.showCancel = true;
      }
    },
    authenticated(val) {
      if (!val) {
        this.$swal(
          "Session Expired",
          "Your token was expaired please login again.",
          "warning"
        ).then(() => {
          // this.$router.push("/login");
          this.setLoginDialog(true);
        });
      }
    },
  },
  methods: {
    ...mapActions("global", [
      "setGlobalStatus",
      "setLoginDialog",
      "initUser",
      "initType",
    ]),
    gotoAccount() {
      this.showCancel = false;
      this.$router.push("/account");
    },
    
    async checkToken() {
      this.authenticated = await backofficeService.valid();
    },
    pollData() {
      this.polling = setInterval(() => {
        if (
          !localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
        ) {
          this.authenticated = false;
        }
      }, 1000);
    },
  },
};
</script>
